import React, {useState} from 'react'
import style from './index.module.scss'
import baseStyle from '../../../styles/base.module.scss';

export const Title = (props) => {
    return (
        <h2 className={style.title} style={{color: (props.color)?props.color:'#4B6584'}}>{props.children}</h2>
    )
}
